var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 400 400",
    fill: "#00075e",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.43 82.5312C173.459 117.556 205.218 122.311 243.126 118.117",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.09 86.5879C140.296 98.5304 134.136 110.444 129.975 126.872",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.429 131.586C117.525 139.947 135.196 152.018 135.196 152.739C135.196 229.349 250.087 260.198 250.087 161.051",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.367 215.001C87.2977 146.373 97.9899 60.6461 164.799 33.3594",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.835 33C307.054 33.0003 275.092 138.363 282.29 203.481",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.274 144.558C186.274 141.486 186.274 138.409 186.274 135.336",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.424 144.452C212.424 139.561 213.503 138.736 212.424 135.019",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.154 218.021C130.491 255.064 179.516 277.407 185.35 311.852C185.489 312.657 186.432 356.683 188.884 356.683C197.622 356.683 188.825 310.119 192.414 304.557C218.528 264.074 247.734 267.575 247.734 213.848",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45 364.747C60.1863 306.064 60.1863 250.394 141.759 217.304",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250.039 217.304C306.492 219.949 354.861 302.323 354.861 356.683",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.454 214.385C252.064 225.679 270.412 261.433 272.454 273.673",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M264.979 274.103C308.843 245.731 308.11 334.174 263.765 302.154C252.367 293.926 265.752 280.95 271.052 272.934",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.572 219.081C125.029 233.198 104.685 262.672 102.722 285.53",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0321 364.747C41.0835 350.369 78.0741 270.547 109.175 286.469C133.814 299.08 128.247 362.011 101.532 364.747",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M285.611 332.155C275.829 331.226 266.341 333.888 256.665 335.278",
    stroke: "#000000",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.f0a0015ffca839e963f897d48a31e9e4.svg";
export { ForwardRef as ReactComponent };